import ProtectedRoute from "./ProtectedRoute";
import RequireProfileCompleted from "./RequireProfileCompleted";

export default function ProtectedAndOnboarded({ children }) {
  return (
    <ProtectedRoute>
      <RequireProfileCompleted>
        {children}
      </RequireProfileCompleted>
    </ProtectedRoute>
  );
}
